import(/* webpackMode: "eager" */ "/opt/project/node_modules/next/dist/client/link.js");
